<script setup>
import { useSertStore } from '@/stores/sertStore'

const storeSert = useSertStore();

const nextSreen = async () => {
    storeSert.goToScreen(storeSert.screens.authPhone)  
    history.pushState(null, "", `#${storeSert.screens.authPhone}`)
    
};

</script>
<template>
    <div class="constructor" data-animation-left>
        <div class="constructor__body">
            <h2 class="constructor__title title2">Создайте идеальный Подарочный Сертификат</h2>
            <p class="constructor__text --bold">СЕРТИФИКАТ THE RINK FITNESS — ЭТО ПРИГЛАШЕНИЕ В МИР ДВИЖЕНИЯ, КРАСОТЫ, СИЛЫ И ВДОХНОВЕНИЯ.</p>
            <p class="constructor__text">Подарите удовольствие от пребывания в уникальном wellness-пространстве для физического и ментального развития!</p>
            <p class="constructor__text">Наш конструктор подарочных сертификатов позволит вам создать и персонализировать подарок всего за несколько шагов. Срок действия — 1 год с момента покупки.</p>           
            <button 
                @click="nextSreen"
                class="btn"
            >
                <span>Создать сертификат</span>
            </button>
        </div>
    </div>
</template>
<style lang='scss' scoped>
</style>